const GameEndReason = {
  NO_USERS: 'no users',
  TOO_MANY_UNANSWERED_QUESTIONS: 'too many unanswered questions',
  ERROR: 'error',
  MAINTENANCE: 'maintenance',
  NO_QUESTIONS_LEFT: 'no questions left',
};

module.exports = {
  GameEndReason,
};
